export const handleUrlWithHashtag = () => {
    // This function is meant to accommodate the old urls on www.24rent.fi temporarily
    // The url usually has the path followed by "/#" then url params which cannot be accessed after #
    // This function removes the "/#" from string so url params may be used
    let windowUrl = window.location.href;
    if (!windowUrl.includes('/#/') && !windowUrl.includes('/#?')){
        // Note: useLocation.search() was previously used to get this string in main files - this is same concept
        return window.location.search;
    } else {
        let newUrl = windowUrl.replace('/#', '')
        const parsedUrl = new URL(newUrl);
        return parsedUrl.search;
    }
}